import { Navigation, Phone } from "lucide-react";
import { mapsQuery, telLink, waLink } from "@/lib/api";
import { Reveal, SectionHead } from "./Reveal";
import { WhatsAppIcon } from "./icons";

export const Location = ({ s }) => {
  const q = mapsQuery(s.maps_query);
  return (
    <section id="localizacao" data-testid="location-section" className="bg-[#0F0F12] py-24 lg:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <SectionHead label={s.location_label} title={s.location_title} subtitle={s.location_text} testid="location-title" />
          <Reveal>
            <address className="not-italic font-display text-2xl sm:text-3xl text-white leading-snug" data-testid="location-address">
              {s.address_line}
              <br />
              <span className="text-[#A1A1AA]">{s.address_city}</span>
              <br />
              <span className="text-base font-sans tracking-[0.2em] text-[#CBD5E1]">{s.address_cep}</span>
            </address>
            <div className="mt-10 flex flex-col gap-3 max-w-sm pr-16 sm:pr-0">
              <a href={`https://www.google.com/maps/dir/?api=1&destination=${q}`} target="_blank" rel="noopener noreferrer" className="btn-lux btn-gold" data-testid="location-directions-button">
                <Navigation className="w-4 h-4" strokeWidth={1.5} /> {s.btn_directions}
              </a>
              <a href={telLink(s.phone_number)} className="btn-lux" data-testid="location-call-button">
                <Phone className="w-4 h-4" strokeWidth={1.5} /> {s.btn_call}
              </a>
              <a href={waLink(s.whatsapp_number, s.wa_msg_reservations)} target="_blank" rel="noopener noreferrer" className="btn-lux" data-testid="location-whatsapp-button">
                <WhatsAppIcon className="w-4 h-4" /> {s.btn_whatsapp}
              </a>
            </div>
          </Reveal>
        </div>
        <Reveal className="lg:col-span-7" delay={0.15}>
          <div className="relative aspect-[4/5] sm:aspect-[4/3] w-full overflow-hidden border border-white/10 bg-[#141418]">
            <iframe
              title="Mapa — Gran Hotel Sé"
              data-testid="location-map"
              src={`https://maps.google.com/maps?q=${q}&z=16&output=embed`}
              className="absolute inset-0 h-full w-full grayscale invert-[0.9] contrast-[0.9]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
